import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RInstelling } from '@cumlaude/service-contract';
import { CheckboxComponent } from '@cumlaude/shared-components-inputs';
import { InstellingLabelsComponent } from '../../../components/instelling-labels/instelling-labels.component';

@Component({
	selector: 'app-instelling-migratie-selectie-list',
	templateUrl: './instelling-migratie-selectie-list.component.html',
	styleUrls: ['./instelling-migratie-selectie-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CheckboxComponent, InstellingLabelsComponent],
})
export class InstellingMigratieSelectieListComponent {
	titel = input.required<string>();
	instellingen = input<RInstelling[]>([]);
	selectedIds = input<string[]>([]);
	disabledIds = input<string[]>([]);

	instellingToggled = output<RInstelling>();

	private readonly selectedIdsSet = computed(() => new Set(this.selectedIds()));
	private readonly disabledIdsSet = computed(() => new Set(this.disabledIds()));

	isSelected(instelling: RInstelling): boolean {
		const id = instelling.id;
		return id !== undefined && this.selectedIdsSet().has(id);
	}

	isDisabled(instelling: RInstelling): boolean {
		const id = instelling.id;
		return id !== undefined && this.disabledIdsSet().has(id);
	}

	onToggle(instelling: RInstelling): void {
		if (this.isDisabled(instelling)) return;
		this.instellingToggled.emit(instelling);
	}
}
